import React, { Fragment, useContext } from "react";
import { Router } from "@reach/router";
import { Dashboard, Accounts } from "../components";
import { AuthContext } from "./../../../AuthProvider";
import { useHistory } from "react-router-dom";

import Appbar from "./appbar";

import firebase from "../../../firebase";
import "firebase/firestore";

export const DashboardRoutes = () => {
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const logout = (event) => {
    event.preventDefault();

    firebase
      .auth()
      .signOut()
      .then((res) => {
        history.push("/auth/login");
      });
  };

  return (
    <Fragment>
      <Appbar style={{ width: "100%" }} logout={logout} user={user} />

      <Router>
        <Dashboard path="dashboard" user={user} />
        {user && (user.rol === "admin" || user.rol === "superadmin") && (
          <Accounts path="/accounts" user={user} />
        )}
      </Router>
    </Fragment>
  );
};
